import React, { useContext } from 'react';
import { MapContext } from '../contexts/MapContext';
import ComparisonButton from './ComparisonButton';
import './JobList.css';

interface Job {
  id: string;
  title: string;
  company: string;
  location: string;
  salary: number;
  employmentType: string;
  remote: boolean;
  coordinates: [number, number];
  industry: string;
  country: string;
}

interface JobCardProps {
  job: Job;
  onClick?: (job: Job) => void;
}

const JobCard: React.FC<JobCardProps> = ({ job, onClick }) => {
  const mapContext = useContext(MapContext);
  
  const handleJobClick = () => {
    if (onClick) {
      onClick(job);
    } else if (mapContext) {
      mapContext.highlightLocation({
        coordinates: job.coordinates
      });
    }
  };
  
  const formatSalary = (salary: number) => {
    if (salary <= 0) return 'Not disclosed';
    return `$${salary.toLocaleString()}`;
  };
  
  return (
    <div 
      className="job-card"
      onClick={handleJobClick}
    >
      <div className="job-header">
        <h4 className="job-title">{job.title}</h4>
        {job.salary > 0 && (
          <div className="job-salary">{formatSalary(job.salary)}</div>
        )}
      </div>
      
      <div className="job-company">{job.company}</div>
      <div className="job-location">{job.location}</div>
      
      <div className="job-details">
        <span className="job-type-tag">{job.employmentType}</span>
        {job.remote && (
          <span className="job-remote-tag">Remote</span>
        )}
        <span className="job-industry-tag">{job.industry}</span>
      </div>
      
      <div className="job-actions">
        <ComparisonButton type="job" item={job} className="compact" />
      </div>
    </div>
  );
};

export default JobCard;